// extracted by mini-css-extract-plugin
export default {"item":"Ticket_item__04NxD","titleWrapper":"Ticket_titleWrapper__VMptM","title":"Ticket_title__2xdD8","date":"Ticket_date__F614e","text":"Ticket_text__oGjqM"};